import * as React from "react";
import {
  Modal,
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Button,
  Avatar,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  FormControl,
  CircularProgress,
  Chip,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {
  MainInputLabel,
  main_button,
  centered_flex_box,
  sec_button,
  confirm_button,
  reject_button,
  ter_button,
  TerInput,
  MainInput,
} from "../../../app/components/Styles";
import {
  generateInvitations,
  generateTickets,
  generateTicketsQRs,
} from "../../../app/store/actions/adminActions";
import ReactFileReader from "react-file-reader";
import Upload from "@mui/icons-material/Upload";
import Download from "@mui/icons-material/Download";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import download from "downloadjs";
import * as XLSX from 'xlsx';
import PopperButton from "../../../app/components/PopperButton";
import { motion } from "framer-motion";

export const GenerateInvitationsModal = ({
  open,
  handleClose,
  event,
  wait,
  generateInvitations
}) => {
  const [file, setFile] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [category, setCategory] = React.useState("");
  const [sendFrom, setSendFrom] = React.useState("613423768526503");
  const [mode, setMode] = React.useState(0); // 0 = bulk, 1 = single
  const [singleInvitation, setSingleInvitation] = React.useState({
    name: "",
    phoneNumber: "",
    email: ""
  });
  const id = useParams().id;

  const handleDeleteFile = () => {
    setFile(null);
    setData([])
  };

  const handleFiles = (files) => {
    const newFile = files[0];
    setFile(newFile);
    var reader = new FileReader();
    reader.readAsArrayBuffer(newFile);
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
          raw: false,
          defval: '',
          blankrows: false
        });
        const d = jsonData.filter(
          (info) => info.name && info.name.trim() !== "" && info.phoneNumber && info.phoneNumber.trim() !== ""
        );
        setData(d);
      } catch (err) {
        console.error('Error processing file:', err);
        notification.error({ message: "Error processing Excel file. Please check the file format." });
      }
    };
  };

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const handleDownloadSample = () => {
    // Create sample data with headers
    const sampleData = [
      { name: "John Doe", phoneNumber: "+201012345678", email: "john.doe@example.com" },
      { name: "Jane Smith", phoneNumber: "+201098765432", email: "jane.smith@example.com" }
    ];

    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(sampleData);
    
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Invitations");
    
    // Generate Excel file buffer
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    
    // Download the file
    download(excelBuffer, "invitations-sample.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  };

  const handleSubmit = async (event) => {
    if (mode === 0) {
      // Bulk upload mode
      if (file) {
        const info = {
          eventId: id,
          data,
          sendFrom,
          category,
        };
        console.log(info)
        generateInvitations(info, handleClose)
        await timeout(500);
      } else {
        notification.error({ message: "Please Upload a valid .xlsx file" });
      }
    } else {
      // Single invitation mode
      if (!singleInvitation.name || !singleInvitation.name.trim()) {
        notification.error({ message: "Name is required" });
        return;
      }
      if (!singleInvitation.phoneNumber || !singleInvitation.phoneNumber.trim()) {
        notification.error({ message: "Phone number is required" });
        return;
      }
      if (!category) {
        notification.error({ message: "Please select a category" });
        return;
      }
      
      const info = {
        eventId: id,
        data: [{
          name: singleInvitation.name.trim(),
          phoneNumber: singleInvitation.phoneNumber.trim(),
          email: singleInvitation.email?.trim() || ""
        }],
        sendFrom,
        category,
      };
      console.log(info)
      generateInvitations(info, handleClose)
      await timeout(500);
    }
  };

  return (
    <Modal 
      open={open} 
      onClose={handleClose}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)'
        }
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '95vw', sm: '600px' },
        maxWidth: '95vw',
        maxHeight: '90vh',
        outline: 'none'
      }}>
        {wait.isLoading && (
          <Paper
            elevation={8}
            sx={{
              ...centered_flex_box,
              minHeight: "50vh",
              p: 4,
              borderRadius: 3,
              backgroundColor: 'var(--platform-surface)',
              border: '1px solid #e0e0e0'
            }}
          >
            <CircularProgress 
              size={60}
              sx={{ 
                color: "var(--primaryPurple)",
                mb: 2
              }} 
            />
            <Typography 
              variant="h6" 
              sx={{ 
                color: "var(--primaryPurple)",
                fontFamily: 'TickitOne, Helvetica, Arial, sans-serif'
              }}
            >
              Generating invitations...
            </Typography>
          </Paper>
        )}
        {!wait.isLoading && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <Paper
              elevation={12}
              sx={{
                p: { xs: 2, sm: 5 },
                borderRadius: 4,
                backgroundColor: 'var(--platform-surface)',
                border: '1px solid #e0e0e0',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                maxHeight: '90vh',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                  width: '6px'
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#f1f1f1',
                  borderRadius: '3px'
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'var(--primaryPurple)',
                  borderRadius: '3px'
                }
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar
                  sx={{
                    m: 2,
                    bgcolor: "var(--primaryPurple)",
                    width: { xs: 56, sm: 80 },
                    height: { xs: 56, sm: 80 },
                    boxShadow: '0 8px 24px rgba(95, 53, 184, 0.3)',
                    '& .MuiSvgIcon-root': {
                      fontSize: '2.5rem',
                      color: 'white'
                    }
                  }}
                >
                  <LocalActivityIcon />
                </Avatar>
                <Typography 
                  component="h1" 
                  variant="h4" 
                  sx={{ 
                    mb: 4,
                    fontSize: { xs: '1.4rem', sm: '2.125rem' },
                    color: 'var(--primaryPurple)',
                    fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  Generate Invitations
                </Typography>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    mb: 3,
                    color: 'var(--tickit-gray500)',
                    fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                    textAlign: 'center',
                    maxWidth: '400px'
                  }}
                >
                  {mode === 0 
                    ? "Upload an Excel file with attendee data to automatically generate and send invitations"
                    : "Enter the attendee details to send a single invitation"}
                </Typography>

                <Box sx={{ width: '100%', mb: 3 }}>
                  <Tabs
                    value={mode}
                    onChange={(e, newValue) => {
                      setMode(newValue);
                      setFile(null);
                      setData([]);
                      setSingleInvitation({ name: "", phoneNumber: "", email: "" });
                    }}
                    sx={{
                      '& .MuiTab-root': {
                        textTransform: 'none',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        color: 'var(--tickit-gray500)',
                        '&.Mui-selected': {
                          color: 'var(--primaryPurple)'
                        }
                      },
                      '& .MuiTabs-indicator': {
                        backgroundColor: 'var(--primaryPurple)'
                      }
                    }}
                    variant="fullWidth"
                  >
                    <Tab label="Bulk Upload" />
                    <Tab label="Single Invitation" />
                  </Tabs>
                </Box>

                {mode === 0 && (
                  <Button
                    fullWidth
                    variant="outlined"
                    size="large"
                    startIcon={<Download />}
                    onClick={handleDownloadSample}
                    sx={{
                      mb: 3,
                      borderRadius: 3,
                      py: 1.5,
                      textTransform: 'none',
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      borderColor: '#e0e0e0',
                      color: 'var(--tickit-gray500)',
                      fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                      '&:hover': {
                        borderColor: 'var(--primaryPurple)',
                        backgroundColor: 'rgba(95, 53, 184, 0.04)',
                        color: 'var(--primaryPurple)'
                      }
                    }}
                  >
                    Download Excel Sample
                  </Button>
                )}

                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{ width: '100%', mt: 2 }}
                >
                  <MainInput
                    margin="normal"
                    autoFocus
                    fullWidth
                    select
                    labelId="num-label"
                    id="category"
                    label="Category"
                    name="category"
                    value={category}
                    onChange={({ target }) => setCategory(target.value)}
                    sx={{
                      mb: 3,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        backgroundColor: 'var(--platform-surface)',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        }
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                      }
                    }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                    },
                  }}
                  >
                    {event?.categories?.map((cat) => (
                      <MenuItem sx={{ color: 'var(--primaryPurple)' }} value={cat.category}>
                        {cat.category} - Category
                      </MenuItem>
                    ))}
                  </MainInput>

                  <MainInput
                    margin="normal"
                    autoFocus
                    fullWidth
                    select
                    labelId="num-label"
                    id="sendFrom"
                    label="Send From Mobile Number"
                    name="sendFrom"
                    value={sendFrom}
                    onChange={({ target }) => setSendFrom(target.value)}
                    sx={{
                      mb: 3,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        backgroundColor: 'var(--platform-surface)',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        }
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                      }
                    }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                    },
                  }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="122093470430020670">
                      +20 10 60414359 
                    </MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="613423768526503">
                      +20 10 27603244 (Main)
                    </MenuItem>
                  </MainInput>

                  {mode === 0 ? (
                    <Box sx={{ mt: 2, mb: 3 }}>
                      <ReactFileReader handleFiles={handleFiles} fileTypes={[".xlsx", ".xls"]}>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="large"
                          startIcon={<Upload />}
                          sx={{
                            borderRadius: 3,
                            py: 1.5,
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            borderColor: '#e0e0e0',
                            color: 'var(--tickit-gray500)',
                            fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                            '&:hover': {
                              borderColor: 'var(--primaryPurple)',
                              backgroundColor: 'rgba(95, 53, 184, 0.04)',
                              color: 'var(--primaryPurple)'
                            }
                          }}
                        >
                          Upload Excel File
                        </Button>
                      </ReactFileReader>
                      {file && (
                        <Chip
                          label={file.name}
                          onDelete={handleDeleteFile}
                          sx={{
                            mt: 2,
                            borderRadius: 2,
                            backgroundColor: 'rgba(95, 53, 184, 0.1)',
                            color: 'var(--primaryPurple)',
                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                            '& .MuiChip-deleteIcon': {
                              color: 'var(--primaryPurple)',
                              '&:hover': {
                                color: 'var(--secPurple)'
                              }
                            }
                          }}
                        />
                      )}
                    </Box>
                  ) : (
                    <Box sx={{ mt: 2, mb: 3 }}>
                      <MainInput
                        margin="normal"
                        fullWidth
                        label="Name"
                        name="name"
                        value={singleInvitation.name}
                        onChange={(e) => setSingleInvitation({ ...singleInvitation, name: e.target.value })}
                        required
                        sx={{
                          mb: 3,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            backgroundColor: 'var(--platform-surface)',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'var(--primaryPurple)',
                              borderWidth: '2px'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'var(--primaryPurple)',
                              borderWidth: '2px'
                            }
                          },
                          '& .MuiInputLabel-root': {
                            color: 'var(--primaryPurple)',
                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                            '&.Mui-focused': {
                              color: 'var(--primaryPurple)'
                            }
                          }
                        }}
                      />
                      <MainInput
                        margin="normal"
                        fullWidth
                        label="Phone Number"
                        name="phoneNumber"
                        value={singleInvitation.phoneNumber}
                        onChange={(e) => setSingleInvitation({ ...singleInvitation, phoneNumber: e.target.value })}
                        required
                        sx={{
                          mb: 3,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            backgroundColor: 'var(--platform-surface)',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'var(--primaryPurple)',
                              borderWidth: '2px'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'var(--primaryPurple)',
                              borderWidth: '2px'
                            }
                          },
                          '& .MuiInputLabel-root': {
                            color: 'var(--primaryPurple)',
                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                            '&.Mui-focused': {
                              color: 'var(--primaryPurple)'
                            }
                          }
                        }}
                      />
                      <MainInput
                        margin="normal"
                        fullWidth
                        label="Email (Optional)"
                        name="email"
                        type="email"
                        value={singleInvitation.email}
                        onChange={(e) => setSingleInvitation({ ...singleInvitation, email: e.target.value })}
                        sx={{
                          mb: 3,
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            backgroundColor: 'var(--platform-surface)',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'var(--primaryPurple)',
                              borderWidth: '2px'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'var(--primaryPurple)',
                              borderWidth: '2px'
                            }
                          },
                          '& .MuiInputLabel-root': {
                            color: 'var(--primaryPurple)',
                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                            '&.Mui-focused': {
                              color: 'var(--primaryPurple)'
                            }
                          }
                        }}
                      />
                    </Box>
                  )}

                  {mode === 0 && data.length > 0 && (
                    <Box sx={{
                      p: 3,
                      mb: 4,
                      borderRadius: 3,
                      backgroundColor: 'rgba(95, 53, 184, 0.05)',
                      border: '2px solid rgba(95, 53, 184, 0.1)'
                    }}>
                      <Typography 
                        variant="body1" 
                        align="center"
                        sx={{
                          color: 'var(--primaryPurple)',
                          fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                          fontWeight: 'bold'
                        }}
                      >
                        Estimated Cost: ${parseFloat(data.length * 0.14).toFixed(2)} +/- ${parseFloat(data.length * 0.07).toFixed(2)}
                      </Typography>
                    </Box>
                  )}
                  {mode === 1 && (
                    <Box sx={{
                      p: 3,
                      mb: 4,
                      borderRadius: 3,
                      backgroundColor: 'rgba(95, 53, 184, 0.05)',
                      border: '2px solid rgba(95, 53, 184, 0.1)'
                    }}>
                      <Typography 
                        variant="body1" 
                        align="center"
                        sx={{
                          color: 'var(--primaryPurple)',
                          fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                          fontWeight: 'bold'
                        }}
                      >
                        Estimated Cost: $0.14 +/- $0.07
                      </Typography>
                    </Box>
                  )}

                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'center', 
                    gap: 3,
                    mt: 4,
                    pt: 3,
                    borderTop: '1px solid #e0e0e0',
                    '& .MuiButton-root': {
                      width: { xs: '100%', sm: 'auto' }
                    }
                  }}>
                    <Button
                      onClick={handleClose}
                      variant="outlined"
                      size="large"
                      sx={{
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        fontWeight: 'bold',
                        borderColor: '#e0e0e0',
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                        '&:hover': {
                          borderColor: '#e0e0e0',
                          backgroundColor: '#f5f5f5',
                          color: '#333'
                        }
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      size="large"
                      disabled={mode === 0 ? !file : !singleInvitation.name || !singleInvitation.phoneNumber || !category}
                      sx={{
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        fontWeight: 'bold',
                        backgroundColor: 'var(--primaryPurple)',
                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                        boxShadow: '0 4px 16px rgba(95, 53, 184, 0.3)',
                        '&:hover': {
                          backgroundColor: 'var(--secPurple)',
                          boxShadow: '0 6px 20px rgba(95, 53, 184, 0.4)',
                          transform: 'translateY(-2px)'
                        },
                        '&:disabled': {
                          backgroundColor: '#ccc',
                          color: 'var(--tickit-gray500)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      {mode === 0 ? 'Send Invitations' : 'Send Invitation'}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </motion.div>
        )}
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  wait: state?.wait,
});

const mapDispatchToProps = { generateInvitations };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateInvitationsModal);
